import { render, staticRenderFns } from "./UpcomingAppointments.vue?vue&type=template&id=775d132c&scoped=true&lang=pug"
import script from "./UpcomingAppointments.vue?vue&type=script&lang=js"
export * from "./UpcomingAppointments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775d132c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default})
